export default (phn_no: string | number, message?: string): string => {
    const WAbaseURL = "https://api.whatsapp.com/send";
    let phn_no_without_plus = "";
    if (typeof phn_no === "string") {
        phn_no_without_plus = phn_no.replace("+", "");
    } else {
        phn_no_without_plus = phn_no.toString();
    }
    const queryString = `?phone=${phn_no_without_plus}&text=${message}`;
    return WAbaseURL + queryString;
};
